import { NgModule } from '@angular/core';
import { UserRolePipe } from './user-role.pipe';
@NgModule({
  declarations: [
    UserRolePipe,
  ],
  imports: [
  ],
  providers: [
  ],
  exports: [UserRolePipe]
})
export class PipeModule { }